import React from 'react'
import { Link } from 'react-router-dom'

// A header nav item with a hover dropdown of subjects (major headings only).
// - `to` / `label` / `colorClass` / `icon`: the trigger link
// - `colorClass`: one of the header `.nav-*` classes; the panel inherits its
//   color so the accent bar + item hover match the trigger.
// - `items`: array of { _id, name, ... }
// - `hrefFor(item)`: builds each dropdown link's path
const NavDropdown = ({ to, label, colorClass = '', icon, items = [], hrefFor }) => (
  <div className="relative group">
    <Link to={to} className={`nav-link ${colorClass}`}>
      {icon}
      {label}
      {items.length > 0 && (
        <svg className="w-3 h-3 ml-0.5 transition-transform group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      )}
    </Link>
    {items.length > 0 && (
      <div className="absolute left-1/2 -translate-x-1/2 top-full pt-3 hidden group-hover:block z-50">
        <div className={`rounded-xl shadow-2xl border border-gray-100 bg-white overflow-hidden min-w-[230px] ${colorClass}`}>
          <div className="h-1 bg-current" />
          <div className="py-2 max-h-[65vh] overflow-y-auto">
            {items.map((it) => (
              <Link
                key={it._id || it.name}
                to={hrefFor(it)}
                className="block px-4 py-2 font-heading text-[13px] font-bold tracking-wide text-gray-700 whitespace-nowrap transition-colors hover:bg-gray-50 hover:text-current"
              >
                {it.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    )}
  </div>
)

// Mobile equivalent: a nav row whose subjects expand/collapse in place.
export const MobileNavGroup = ({ to, label, colorClass = '', icon, items = [], hrefFor, open, onToggle }) => (
  <div className={colorClass}>
    <div className="flex items-stretch">
      <Link to={to} className={`mobile-nav-link ${colorClass} flex items-center gap-3 flex-1`}>
        {icon}
        {label}
      </Link>
      {items.length > 0 && (
        <button
          type="button"
          onClick={onToggle}
          aria-label={`Toggle ${label} subjects`}
          className="px-3 flex items-center text-current"
        >
          <svg className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      )}
    </div>
    {open && items.length > 0 && (
      <div className="mt-1 ml-8 flex flex-col border-l-2 border-current pl-3">
        {items.map((it) => (
          <Link
            key={it._id || it.name}
            to={hrefFor(it)}
            className="py-1.5 font-heading text-[13px] font-bold tracking-wide text-gray-700 hover:text-current"
          >
            {it.name}
          </Link>
        ))}
      </div>
    )}
  </div>
)

export default NavDropdown
